
import Vue from 'vue';
import { UserModel, SolutionModel } from '@descomplica/dex-models';
import CommentInput from './comment/CommentInput.vue';
import Content from './contents/Content.vue';
import AvatarLabel from './AvatarLabel.vue';
import CommentCard from './comment/CommentCard.vue';
import ContentAndSolutions from './ContentAndSolutions.vue';
import { UnifiedCommentModel } from '@/models/UnifiedCommentModel';
import { FileModel } from '../models/FileModel';

export default Vue.extend({
  components: {
    CommentInput,
    Content,
    AvatarLabel,
    CommentCard,
    ContentAndSolutions,
  },
  props: {
    user: {
      type: Object as Vue.PropType<UserModel>,
      required: true,
    },
    solutions: {
      type: Array as Vue.PropType<SolutionModel[]>,
      default: () => [],
    },
    comments: {
      type: Array as Vue.PropType<UnifiedCommentModel[]>,
      default: () => [],
    },
    questionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isSending: false,
    };
  },
  computed: {
    professorSolution(): SolutionModel | null {
      return this.solutions.find((solution: SolutionModel) => solution.user.isAdmin()) || null;
    },
  },
  methods: {
    async submit(params: { text: string; files: FileModel[] }) {
      const { text } = params;
      if (text) {
        this.isSending = true;
        await this.$store
          .dispatch('CREATE_COMMENT', {
            questionId: this.questionId,
            userId: this.user.id,
            text,
          })
          .finally(() => {
            this.isSending = false;
          });
      }
    },
  },
});
